import { c as _c } from "react/compiler-runtime";
import { usePublicRewards } from '@/api/skippay/publicRewards';
import Loader from '@/components/Loader';
import { RewardBoxes } from '@/components/boxes';
import { Link } from '@/components/links';
import { Text, Headline } from '@/components/typography';
import { LINKS, SELF_CARE_LINKS } from '@/constants/links';
import { Trans, useTranslation } from 'react-i18next';
export function Discounts() {
  const $ = _c(18);
  const {
    t
  } = useTranslation("rewards");
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      limit: 8
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    data,
    isPending,
    isError
  } = usePublicRewards(t0);
  let t1;
  if ($[1] !== data || $[2] !== isError || $[3] !== isPending) {
    t1 = function renderContent() {
      if (isPending) {
        return <Loader />;
      }
      if (isError || !data) {
        return null;
      }
      return <RewardBoxes className="mt-10 lg:mt-12" items={data.data.map(_temp)} />;
    };
    $[1] = data;
    $[2] = isError;
    $[3] = isPending;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const renderContent = t1;
  let t2;
  if ($[5] !== t) {
    t2 = t("discounts.title");
    $[5] = t;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== t2) {
    t3 = <Headline as="h3" variant="h4" className="mt-16 mb-3 text-center whitespace-pre-wrap lg:mt-20 lg:mb-5">{t2}</Headline>;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Link to={LINKS().promotions} analyticsParam="rewardDiscounts" testId="rewardDiscounts" />;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t) {
    t5 = <Text variant="p2" className="mx-auto max-w-192 px-4 text-center text-gray-800"><Trans t={t} i18nKey="discounts.paragraph">{t4}</Trans></Text>;
    $[10] = t;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== renderContent) {
    t6 = renderContent();
    $[12] = renderContent;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t3 || $[15] !== t5 || $[16] !== t6) {
    t7 = <section className="relative z-10">{t3}{t5}{t6}</section>;
    $[14] = t3;
    $[15] = t5;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  return t7;
}
function _temp(item) {
  return {
    image: item.productImages[0].url || "",
    link: {
      analyticsParam: `rewardDiscounts-${item.id}`,
      testId: `rewardDiscounts-${item.id}`,
      to: SELF_CARE_LINKS.rewardsOverviewDetail(item.id)
    },
    title: item.title
  };
}